import { Address } from './address';
import { BeneficiaireDiplome } from './beneficiareDiplome';
import { Departement } from './departement';
import { EligibiliteBeneficiaire } from './eligibiliteBeneficiaire';
import { NiveauEtude } from './niveauEtude';
import { NiveauQualification } from './niveauQualification';
import { Region } from './region';
import { SituationFamiliale } from './situationFamiliale';
import { StatutProfessionnel } from './statutProfessionnel';
import { TauxReconnaissance } from './tauxReconnaissance';
import { TypeHandicap } from './typeHandicap';

export class Beneficiaire {
	id: number;
	firstName: string;
	lastName: string;
	birthDate: string;
	telephone: string;
	email: string;
	address: Address;
	genre: string;
	tauxReconnaissance: TauxReconnaissance;
	niveauEtude: NiveauEtude;
	niveauQualification: NiveauQualification;
	handicapPrincipal: string;
	modeCommunication: string;
	degreSurdite: string;
	typeHandicaps: TypeHandicap[];
	statutProfessionnel: StatutProfessionnel;
	eligibiliteBeneficiaire: EligibiliteBeneficiaire;
	situationFamiliale: SituationFamiliale;
    origineHandicap: string;
    doleances: string;
    rapportHandicap: string;
    environnementSocial: string;
	diplomes: BeneficiaireDiplome[];
	region: Region;
	regionAutre: Region;
	departement: Departement;
	
	constructor(
		options: {
			id?: number;
			firstName?: string;
			lastName?: string;
			birthDate?: string;
			telephone?: string;
			email?: string;
			address?: Address;
			genre?: string;
			tauxReconnaissance?: TauxReconnaissance;
			niveauEtude?: NiveauEtude;
			niveauQualification?: NiveauQualification;
			typeHandicaps?: TypeHandicap[];
			diplomes?: BeneficiaireDiplome[];
			statutProfessionnel?: StatutProfessionnel;
			eligibiliteBeneficiaire?: EligibiliteBeneficiaire;
			situationFamiliale?: SituationFamiliale;
			origineHandicap?: string;
			doleances?: string;
			rapportHandicap?: string;
			environnementSocial?: string;
		} = {}
	) {
		this.id = options.id || null;
		this.firstName = options.firstName || null;
		this.lastName = options.lastName || null;
		this.birthDate = options.birthDate || null;
		this.telephone = options.telephone || null;
		this.email = options.email || null;
		this.address = options.address || null;
		this.genre = options.genre || 'Féminin';
		this.tauxReconnaissance = options.tauxReconnaissance || null;
		this.niveauEtude = options.niveauEtude || null;
		this.niveauQualification = options.niveauQualification || null;
		this.statutProfessionnel = options.statutProfessionnel || null;
		this.eligibiliteBeneficiaire = options.eligibiliteBeneficiaire || null;
		this.situationFamiliale = options.situationFamiliale || null;
		this.origineHandicap = options.origineHandicap || null;
		this.doleances = options.doleances || null;	
		this.rapportHandicap = options.rapportHandicap || null;	
		this.environnementSocial = options.environnementSocial || null;	
		this.typeHandicaps = options.typeHandicaps || [];
		this.diplomes = options.diplomes || [];
	}
}
